import { ColumnMeta } from '@api/api/screener';
import { ActiveFilterOptions } from '@terminal/components/filters/Filters';
import { LIVE_ONE_DAY_RETURN_COLUMN_META_VALUE_FIELD } from '@terminal/views/screener/results/constants';

const COLUMN_META_HORIZON_FIELD_VALUE = /horiz=(\w+)/;
const getHorizonFromColumnMetaField = (field?: string) => {
  if (field === LIVE_ONE_DAY_RETURN_COLUMN_META_VALUE_FIELD) return '1d';
  return field?.match(COLUMN_META_HORIZON_FIELD_VALUE)?.[1];
};

const getHorizonFromHeaderFilterOptions = (
  headerFilter?: ActiveFilterOptions
) => headerFilter?.options.find(o => o.childName === 'Timeframe')?.key;

export const checkIfHorizonsMatch = (
  columnMeta?: ColumnMeta,
  headerFilter?: ActiveFilterOptions
) => {
  const columnMetaHorizon = getHorizonFromColumnMetaField(columnMeta?.field);
  const headerFilterHorizon = getHorizonFromHeaderFilterOptions(headerFilter);
  return (
    !!columnMetaHorizon &&
    !!headerFilterHorizon &&
    columnMetaHorizon === headerFilterHorizon
  );
};
